import { render, staticRenderFns } from "./activeAccount.vue?vue&type=template&id=1b5b3ddc&scoped=true&lang=html&"
import script from "./activeAccount.vue?vue&type=script&lang=js&"
export * from "./activeAccount.vue?vue&type=script&lang=js&"
import style0 from "./activeAccount.vue?vue&type=style&index=0&id=1b5b3ddc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b3ddc",
  null
  
)

component.options.__file = "activeAccount.vue"
export default component.exports